import { useMutation, useQueryClient } from 'react-query';
import { scenarioClient } from '../../util/scenarioClient';

export const useDeleteScenario = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (scenarioId: string) => {
      await scenarioClient.delete(`/scenario/${scenarioId}`);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('scenarios');
      },
    },
  );
};
